module.exports = __webpack_public_path__ + "img/four3Red.51c8c93c.jpg";